var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlw__cti-sidebar__content",style:({ width: '100%' })},[_vm._l((_vm.interactions),function(ref){
var type = ref.type;
var data = ref.data;
var id = ref.id;
return _c('Interaction',{key:id,attrs:{"id":id,"data":data,"type":type}})}),_c('AddInteraction')],2)}
var staticRenderFns = []

export { render, staticRenderFns }